// removed by extract-text-webpack-plugin
module.exports = {"base":"Battle_base--2MO3x","header":"Battle_header--24pBi","base__sortie":"Battle_base__sortie--3-k22","baseSortie":"Battle_base__sortie--3-k22","base__fort-battle":"Battle_base__fort-battle--2Mcrv","baseFortBattle":"Battle_base__fort-battle--2Mcrv","caption":"Battle_caption--2gtCJ","list":"Battle_list--3OxwG","item":"Battle_item--1Ce4p"};


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/Battle/Battle.scss
// module id = 484
// module chunks = 11 12